import axios from "axios";
import settings from "../settings/settings.js"
const ajax = axios.create({
    baseURL: settings.iHubBaseUrlApi
})


ajax.interceptors.request.use((config) => {
    let token = localStorage.getItem('auth')
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
}, (error) => {
    return Promise.reject(error)
})


ajax.interceptors.response.use(response => {
    return response;
},
    error => {
        let html = ''
            let errs;
            try{
                errs = JSON.parse(error.response.data.Message)
            }
            catch(e){
                errs = error.response.data.Message
            }
            if (Array.isArray(errs)) {
                errs.forEach(err => {
                    html += err + "</br>"
                });
                return Promise.reject(html);
            }{
                html = errs
                return Promise.reject(html);
            }
        // return Promise.reject(error)

    })


class serviceihub {
    getCustomerContactByCustomerId(id, all = false, ihubapplicationId) {
        return ajax
            .get(settings.iHubBaseUrlApi + `/CustomerContacts/${id}?all=${all}&ihubapplicationId=${ihubapplicationId}`)
    }

    getCustomerContactXLicenseXProfilesByCustomerId(id, all = false, ihubapplicationId) {
        return ajax
            .get(settings.iHubBaseUrlApi + `/CCXLXPs/${id}?all=${all}&ihubapplicationId=${ihubapplicationId}`)
    }

    addInstaller(installer) {
        return ajax.post(settings.iHubBaseUrlApi + `/CCXLXPs`, installer)
    }

    updateCustomerContacts(users) {
        return ajax.put(settings.iHubBaseUrlApi + `/CCXLXPs`, users)
    }

    updateCustomerContact(user) {
        return ajax.put(settings.iHubBaseUrlApi + `/CustomerContact`, user)
    }

    updateCustomerContactPassword(o) {
        return ajax.put(settings.iHubBaseUrlApi + `/CustomerContactPassword`, o)
    }

    getProfilesByCustomerId(customerId, ihubapplication) {
        return ajax.get(settings.iHubBaseUrlApi + `/GetProfilesByCustomerId/${customerId}?ihubApplicationId=${ihubapplication}`)
    }

    getCustomer(id) {
        return ajax.get(settings.iHubBaseUrlApi + `/Customers/${id}`)
    }

    updateCustomer(customer) {
        return ajax.put(settings.iHubBaseUrlApi + `/Customers/${customer.Id}`, customer)
    }

    requestDemo(customer) {
        return ajax.post(settings.iHubBaseUrlApi + `/Customers/RequestDemo`, customer)
    }
}


export { serviceihub }


// WEBPACK FOOTER //
// ./src/services/service.ihub.js